import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/site/Reveal";

const SPANS = [
  "col-span-2 row-span-2",
  "",
  "",
  "row-span-2",
  "col-span-2",
  "",
];

export default function Gallery({ gallery }) {
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" data-testid="gallery-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <SectionHeading kicker="Moments of Glory" title="The Gallery of Crowned Dreams" testid="gallery-heading" />

      <div className="grid auto-rows-[160px] grid-cols-2 gap-3 md:auto-rows-[210px] md:grid-cols-4 md:gap-4">
        {gallery.map((g, i) => (
          <Reveal key={g.id || i} delay={(i % 4) * 0.06} className={SPANS[i % SPANS.length]}>
            <button
              data-testid={`gallery-item-${i}`}
              onClick={() => setActive(g)}
              className="group relative block h-full w-full overflow-hidden"
            >
              <img
                src={g.image}
                alt={g.title}
                className="h-full w-full bg-black object-contain transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 transition-colors duration-500 group-hover:bg-black/40" />
              <div className="absolute inset-x-0 bottom-0 translate-y-4 p-4 text-left opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                <span className="block text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">{g.category}</span>
                <span className="font-display text-lg text-white">{g.title}</span>
              </div>
            </button>
          </Reveal>
        ))}
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            data-testid="gallery-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[70] flex items-center justify-center bg-black/95 p-6 backdrop-blur-sm"
            onClick={() => setActive(null)}
          >
            <button
              data-testid="gallery-lightbox-close"
              className="absolute right-6 top-6 text-[#D4AF37]"
              aria-label="Close"
            >
              <X className="h-8 w-8" strokeWidth={1} />
            </button>
            <motion.figure
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              className="max-h-full max-w-4xl"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={active.image} alt={active.title} className="max-h-[80vh] w-full object-contain" />
              <figcaption className="mt-4 text-center">
                <span className="font-script text-2xl text-[#D4AF37]">{active.title}</span>
              </figcaption>
            </motion.figure>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
